import styled from 'styled-components'
import { Empty } from 'antd'

const AnEmptyStyled = styled(Empty)``
export default AnEmptyStyled
